export default {
	'site-access': 'Site Access',
	'developer': 'Developer Access',
	'edit-content': 'Edit Content',
	'posillico': 'Posillico',
	'ppark': 'PPark NJ',
	'construx': 'Construx',
	'materials-project-portal': 'Materials Project Portal',
};
